import { LoginScreenStep } from '@/containers/@screens/LoginScreen/LoginScreen'
import { trans } from '@/helpers/trans'

export const getLoginScreenTitleText = (step: LoginScreenStep, isUserNotFound: boolean): string => {
    if (step === LoginScreenStep.pincode) {
        return trans('containers.loginScreen.enterPincode')
    }

    if (isUserNotFound) {
        return trans('containers.loginScreen.userNotFound')
    }

    return trans('containers.loginScreen.title')
}
